import request from '@/utils/request'
import axios from 'axios'

export const stockApi = {
  // 批量入库
  stockIn(data) {
    return request({
      url: '/inventory-management-api/stock/in',
      method: 'POST',
      data
    })
  },

  // 批量出库
  stockOut(data) {
    return request({
      url: '/inventory-management-api/stock/out',
      method: 'POST',
      data
    })
  },

  // 库存调整
  adjust(data) {
    return request({
      url: '/inventory-management-api/stock/adjust',
      method: 'POST',
      data
    })
  },

  // 查询出入库记录
  getMovements(data) {
    return request({
      url: '/inventory-management-api/stock/movements',
      method: 'POST',
      data
    })
  },

  // 查询出入库统计
  getStatistics(data) {
    return request({
      url: '/inventory-management-api/stock/statistics',
      method: 'POST',
      data
    })
  },

  // 查询出入库统计汇总
  getStatisticsSum(data) {
    return request({
      url: '/inventory-management-api/stock/statisticsSum',
      method: 'POST',
      data
    })
  },

  // 编辑库存变动记录
  edit(data) {
    return request({
      url: '/inventory-management-api/stock/edit',
      method: 'POST',
      data
    })
  },

  // 删除库存变动记录
  delete(data) {
    return request({
      url: '/inventory-management-api/stock/delete',
      method: 'POST',
      data
    })
  },

  // 批量出入库
  batch(data) {
    return request({
      url: '/inventory-management-api/stock/batch',
      method: 'POST',
      data
    })
  },

  // 查询出入库记录（按记录分组）
  getRecords(data) {
    return request({
      url: '/inventory-management-api/stock/records',
      method: 'POST',
      data
    })
  },

  // 更新SKU数量（保留向后兼容）
  updateSkuQuantity(movementId, quantity) {
    return request({
      url: '/inventory-management-api/stock/edit',
      method: 'POST',
      data: {
        sessionId: 'system_session',
        id: movementId,
        quantity: quantity
      }
    })
  },

  // 更新库存变动记录（支持修改更多字段）
  updateMovement(movementId, updateData) {
    return request({
      url: '/inventory-management-api/stock/edit',
      method: 'POST',
      data: {
        sessionId: 'system_session',
        id: movementId,
        ...updateData
      }
    })
  },

  // 删除SKU记录
  deleteSku(movementId) {
    return request({
      url: '/inventory-management-api/stock/delete',
      method: 'POST',
      data: {
        sessionId: 'system_session',
        id: movementId
      }
    })
  },

  // 月度汇总
  getMonthlySummary(data) {
    return request({
      url: '/inventory-management-api/stock/monthlySummary',
      method: 'POST',
      data
    })
  },

  // 日汇总
  getDailySummary(data) {
    return request({
      url: '/inventory-management-api/stock/dailySummary',
      method: 'POST',
      data
    })
  },

  // 导出出入库统计
  exportStatistics(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }

    return axios({
      url: '/inventory-management-api/stock/statistics/export',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 30000
    })
  },

  // 导出日汇总
  exportDailySummary(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }

    return axios({
      url: '/inventory-management-api/stock/dailySummary/export',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 30000
    })
  }
}